export const TRANSLATION_NAMESPACES = [
  'common',
  'hero',
  'services',
  'products',
  'contact',
  'support',
  'training',
  'features',
  'workflow',
  'adsync',
  'lemonldap',
  'whatsnew',
  'company',
  'core-services',
  'saas',
  'nextcloud',
  'openldap',
  'expertise',
  'request',
  'footer'
] as const;

export const DEFAULT_NAMESPACE = 'common';